import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useAccordionContext } from './AccordionPanelContext';
export const AccordionContent = ({ children, className, ...props }) => {
    const { isOpen } = useAccordionContext();
    return isOpen ? (_jsx("div", { ...props, className: classNames('py-5 dark:bg-gray-900', className), children: children })) : null;
};
